import { createSlice } from "@reduxjs/toolkit";
import {getAllBeneficiaryList } from "./ThunkAction";
import { iBeneficiaryState, REDUCER_NAME } from "./Types";

const initialState: iBeneficiaryState = {
  isLoading: false,
  beneficiaryList: [], 
  errorMessage: null,
};

export const beneficiarySlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetBeneficiaryState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBeneficiaryList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBeneficiaryList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.beneficiaryList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getAllBeneficiaryList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch data";
        state.isLoading = false;
      })
      
      
    
  },
});

export const { resetBeneficiaryState } = beneficiarySlice.actions;
export default beneficiarySlice.reducer;
  